<template>
  <v-container class="back">
      <div class="acknowledgment">Für meine geliebte Frau</div>
    <div class="text-center title">
      <h2 class="display-2 font-weight-bold my-2">30 Jahr, blondes Haar</h2>
      <p class="subheading font-weight-regular">
        Alles Gute zum Geburtstag 🎂
      </p>
    </div>
  </v-container>
</template>

<script>
  export default {
    name: 'Home',

    data: () => ({

    }),
  }
</script>

<style scoped>
  .title {
    position: absolute;
    bottom: 90px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 10px;
    width: 85%;
    left: 10px;
    right: 10px;
    margin-left:auto;
    margin-right:auto;

  }

  .acknowledgment {
    position: absolute;
    right: 20px;
    font-size: x-small;
  }

  .back {
    background-image: url("../assets/margit-back.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 100%;
  }
</style>
